module.exports = __webpack_public_path__ + "static/img/wechat.dfe9165.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/wechat.jpg
// module id = Njwf
// module chunks = 1